<script setup lang="ts">
const props = defineProps<{
  tabs: { key: string; title: string | undefined }[]
}>()

const route = useRoute()
</script>

<template>
  <div class="border-b-4 border-white bg-neutral-100">
    <div
      class="container flex justify-between whitespace-nowrap py-2 text-sm font-bold text-neutral-400 @container"
    >
      <NuxtLink
        v-for="(tab, index) in props.tabs"
        :key="tab.key"
        :to="route.path + '#' + tab.key"
        class="group flex items-center gap-2 no-underline transition-all"
        :class="{
          hidden: index === 0,
          '@5xl:flex': tabs.length >= 7,
          '@4xl:flex': tabs.length < 7,
        }"
      >
        <img
          v-if="index > 0"
          class="mr-3 contrast-50 invert filter transition-all duration-300 group-hover:invert-0 md:mr-0"
          :src="'/img/svg/icons/' + tab.key + '.svg'"
          :height="20"
          :width="20"
        />
        <div
          class="hidden text-xs transition-all duration-300 group-hover:!text-black @4xl:block @5xl:text-sm"
        >
          {{
            tab?.title?.startsWith('base')
              ? $t(tab.title)
              : tab.title?.split('_').join(' ')
          }}
        </div>
      </NuxtLink>
    </div>
  </div>
</template>
